<mat-form-field class="Folder-Dropdown">
  <mat-label>Folder</mat-label>
  <mat-select [(ngModel)]="selectedFolder" (selectionChange)="onFolderChange()">
    <mat-option value="Inbox">Inbox({{ inboxCount | formatMailboxMessageCount }})</mat-option>
    <mat-option value="Friends">Friends ({{ friendsCount | formatMailboxMessageCount }})</mat-option>
    <mat-option value="Family">Family({{ familyCount | formatMailboxMessageCount }})</mat-option>
    <mat-option value="Work">Work({{ workCount | formatMailboxMessageCount }})</mat-option>
  </mat-select>
</mat-form-field>
<mat-slide-toggle
  class=""
  id="space-to-bottom-left"
  color="primary"
  [ngModel]="showAllMailboxMessages"
  (ngModelChange)="showAllMessagesChange($event)"
  >
  Show Archived</mat-slide-toggle
  ><mat-slide-toggle
  class=""
  id="space-to-bottom-left-unread"
  color="primary"
  [ngModel]="showUnreadOnly"
  (ngModelChange)="sortUnreadMessagesChange($event)"
  >
  Show Unread Messages Only</mat-slide-toggle
  >
  <lcs-loading-overlay class="flex-dir-col">
    <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="mailboxMessageDisplayItems" style="font-size: 0.75em">
        <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
        <tr lcs-row *lcsResponsiveRowDef></tr>
        <ng-container lcsColumnDef="Timestamp" width="5">
          <th lcs-header-cell *lcsHeaderCellDef id="timestamp-column-header">Timestamp</th>
          <td lcs-cell *lcsCellDef="let mailboxMessage; let index = dataIndex" (dblclick)="onPlayClick(index)">
            <div class="timestamp-unread-column">
              @if (!mailboxMessage.isRead && !mailboxMessage.isArchived) {
                <div
                  class="unread-icon"
                  matTooltip="Unread Message"
                ></div>
              }
              <a>
                {{ mailboxMessage.timestamp | date : 'MM/dd/yy hh:mm aa' }}
              </a>
            </div>
          </td>
        </ng-container>
        <ng-container lcsColumnDef="Sender" width="4">
          <th lcs-header-cell *lcsHeaderCellDef id="sender-column-header">Sender</th>
          <td lcs-cell *lcsCellDef="let mailboxMessage; let index = dataIndex" (dblclick)="onPlayClick(index)">
            <a>
              {{ mailboxMessage.sender | formatPhoneNumbers }}
            </a>
          </td>
        </ng-container>
        <ng-container lcsColumnDef="isActive" width="1">
          <th lcs-header-cell *lcsHeaderCellDef id="active-column-header">Active</th>
          <td lcs-cell *lcsCellDef="let mailboxMessage">
            @if (!mailboxMessage.isArchived) {
              <mat-icon>check</mat-icon>
            }
          </td>
        </ng-container>
        <ng-container lcsColumnDef="Actions" width="2">
          <th lcs-header-cell *lcsHeaderCellDef id="sender-column-header"></th>
          <td
            lcs-cell
            *lcsCellDef="let mailboxMessage; let index = dataIndex"
            (dblclick)="onPlayClick(index, $event)"
            >
            <div class="message-actions">
              @if (
                index === currentPlaylistIndex &&
                showAudioPlayer === true &&
                isLoading === false &&
                showError === false
                ) {
                <div
                  class="mailbox-messages-now-playing"
                     [class.mailbox-messages-eq-appear]="
                        index === currentPlaylistIndex &&
                        isLoading === false &&
                        showError === false &&
                        isPaused === false
                     "
                     [class.mailbox-messages-eq-disappear]="
                        !(
                           index === currentPlaylistIndex &&
                           isLoading === false &&
                           showError === false &&
                           isPaused === false
                        )
                     "
                  >
                  <svg xmlns="http://www.w3.org/2000/svg" class="mailbox-messages-equalizer" viewBox="0 0 100 100">
                    <g>
                      @for (index of [0, 1, 2, 3, 4]; track index) {
                        <ng-container>
                          <rect
                            [ngClass]="isPaused ? 'mailbox-messages-bar-paused' : 'mailbox-messages-bar-playing'"
                            [attr.transform]="'translate(' + index * 20 + ',0)'"
                            y="15"
                          ></rect>
                        </ng-container>
                      }
                    </g>
                  </svg>
                </div>
              }
              @if (isLoading && index === currentPlaylistIndex && showError === false) {
                <mat-spinner
                  class="mailbox-messages-loading-spinner"
                  [diameter]="16"
                ></mat-spinner>
              }
              @if (showError && index === currentPlaylistIndex) {
                <mat-icon
                  class="message-error"
                  matTooltip="Error playing message"
                  >
                  error_outline
                </mat-icon>
              }
              @if (showAudioPlayer === true && mailboxMessage.file && !mailboxMessage.isArchived) {
                <button
                  type="button"
                  aria-label="Play/Pause the Selected Message"
                  matTooltip="{{ index === currentPlaylistIndex && isPaused === false ? 'Pause' : 'Play' }}"
                  mat-icon-button
                  [disabled]="disabled"
                  (click)="onPlayClick(index)"
                  id="mailbox-play-message-{{ index }}"
                  >
                  <mat-icon>
                    {{ index === currentPlaylistIndex && isPaused === false ? 'pause' : 'play_arrow' }}
                  </mat-icon>
                </button>
              }
              @if (mailboxMessage.file && !mailboxMessage.isArchived) {
                <button
                  type="button"
                  aria-label="Mailbox Message Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="mailboxMessageRegisterItemMenu"
                  [matMenuTriggerData]="{ $implicit: mailboxMessage, index: index }"
                  [disabled]="disabled"
                  id="mailbox-message-register-option-menu-button-{{ index }}"
                  >
                  <mat-icon> more_horiz </mat-icon>
                </button>
              }
            </div>
          </td>
        </ng-container>
      </table>
    </lcs-responsive-table>
    @if (showAudioPlayer && fileTokens.length && mailboxMessageDisplayItems.length) {
      <ndt-audio-playlist-player
        class="mailbox-messages-playlist-player"
        [fileTokens]="fileTokens"
        [autostart]="false"
        >
      </ndt-audio-playlist-player>
    }
  </lcs-loading-overlay>
  @if (!fileTokens.length || !mailboxMessageDisplayItems.length) {
    <div> No messages found. </div>
  }
  <mat-menu #mailboxMessageRegisterItemMenu="matMenu">
    <ng-template matMenuContent let-message="$implicit" let-index="index">
      @if (message.file) {
        <a mat-menu-item
          id="mailbox-message-register-option-download"
          [attr.download]="message.sender"
          [attr.href]="message.file?.fileToken | fileUrl"
          class="text-primary"
          >Download</a
          >
      }
      @if (message.file) {
        <button
          type="button"
          mat-menu-item
          id="mailbox-message-register-option-play"
          (click)="onPlayClick(index)"
          >
          {{ index === currentPlaylistIndex && isPaused === false ? 'Pause' : 'Play' }}
        </button>
      }
      @if (message.isRead) {
        <button
          type="button"
          mat-menu-item
          id="mailbox-message-register-option-delete"
          (click)="onMarkUnreadClick(index)"
          >
          Mark as Unread
        </button>
      }
      @if (!message.isArchived) {
        <button
          type="button"
          mat-menu-item
          [matMenuTriggerFor]="moveToFolderMenu"
          [matMenuTriggerData]="{ message: message }"
          >
          Move to Folder
        </button>
      }
      @if (!message.isArchived) {
        <button
          type="button"
          mat-menu-item
          id="mailbox-message-register-option-delete"
          (click)="onDeleteClick(index)"
          >
          Delete
        </button>
      }
    </ng-template>
  </mat-menu>
  <mat-menu #moveToFolderMenu="matMenu">
    <ng-template matMenuContent let-data="message">
      <button mat-menu-item (click)="onMoveToFolder(data, MailboxFolders.Inbox)">Inbox</button>
      <button mat-menu-item (click)="onMoveToFolder(data, MailboxFolders.Friends)">Friends</button>
      <button mat-menu-item (click)="onMoveToFolder(data, MailboxFolders.Family)">Family</button>
      <button mat-menu-item (click)="onMoveToFolder(data, MailboxFolders.Work)">Work</button>
    </ng-template>
  </mat-menu>
